module.exports = __webpack_public_path__ + "img/RL210BT.43117881.png";